import React from 'react';
import Header from './Header.js';
import Footer from './Footer.js';
import { Link } from "react-router-dom";
import ImageCarousel from "./ImageCarousel";

const Homepage = () => {
  return (
    <div className="home-page">
        <div className="position-relative full-height">
            <video className="video-background" autoPlay muted loop>
                <source src="/video/Hero_Background-Video.m4v" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
             <Header />
            <div className="content">
                <h1>
                    Revolutionizing Measurements
                </h1>
                <h2 className="font-weight-extra-light">Smart Sizing. Zero Hassle</h2>
                <div>
                    <p className="padding-top-xxl font-md fw-light">Let Us Understand You</p>
                    <Link to="/survey">
                    <button type="button" className="survey-btn-dark fw-light">
                        Take Our Survey
                    </button>
                    </Link>
                </div>
            </div>
        </div>

        <section className="bg-black-blue">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center">
                    <div className="col-md-6 theme-color">
                        <h2>How It Works</h2>
                        <p className="custom-para font-md font-weight-extra-light padding-right-xxl">
                            Leveraging state-of-the-art AI, we extract key body
                            metrics from 2 images to generate highly accurate 
                            measurements. With machine learning trained on
                            proprietary datasets, our system ensures precise
                            and consistent results for all users.
                        </p>

                        <div className="font-large padding-top-xl">
                            3 Step Breakdown <br/>
                            Snap. Measure. Implement.
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src="images/mobile.png" className="img-fluid" alt="Meas-Sol" style={{height:'628px'}} />
                    </div>
                </div>
            </div>
        </section>

        <section className="content-bg full-height">
            <div className="container">
                <div className="row d-flex justify-content-center">
                    <div className="col-md-12 theme-color padding-top-xxl text-center">
                        <h1>Why Meas-Sol ?</h1>
                        <p className="custom-para font-md font-weight-extra-light padding-left-xl padding-right-xl padding-top-sm">
                            Speed, precision, and scalability—AI sizing delivers instant, data-driven measurements that optimize your business operations. Whether you’re outfitting employees, manufacturing uniforms, or tailoring custom pieces, our technology ensures consistent accuracy with zero manual input. 
                            Reduce returns, enhance customer satisfaction, and make smarter sizing decisions—all in just seconds.
                        </p>

                        <div className="font-md fw-medium padding-top-xl">
                           Precision and efficiency—right at your fingertips
                        </div>
                    </div>
                   
                </div>
            </div>
        </section>

         <section className="black-bg padding-top-xxl padding-bottom-xxl">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center">
                    <div className="col-md-6 theme-color">
                        <h2>Measure Smarter, Fit  Better</h2>
                        <p className="custom-para font-md fw-light padding-right-xl padding-top-sm">
                            With advanced machine-learning algorithms analyzing key body points, you can rely on consistent, data-driven measurements tailored to every body type. Say goodbye to sizing uncertainties and experience a smarter, more reliable way to measure.
                        </p>                        
                    </div>
                    <div className="col-md-6">
                        <ImageCarousel />
                    </div>
                </div>
            </div>
        </section>
     
        <div className="full-height theme-bg theme-color d-flex justify-content-center align-items-center">
            <div className="text-center">
                <h2>
                    Let’s Get In Touch
                </h2>
                <div>
                  <p className="padding-top-sm custom-para font-md fw-light">
                      Contact us today to discover how AI body scanning can <br/>
                      maximize efficiency and accelerate growth.
                  </p>
                  <div className="padding-top-xl">
                      <Link to="/contact" className="nav-link">
                          <button type="button" className="survey-btn fw-light">
                              Contact Us
                          </button>
                      </Link>
                  </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
  );
}

export default Homepage;